import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    route: null,
    permissions: '',
  },
  mutations: {
    saveRoute(state, route) {
      state.route = route
    },
    setPermissions(state, permissions) {
      state.permissions = permissions
    }
  },
  actions: {
  },
  modules: {
  }
})
